<template>
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8807 1.22634C11.0678 0.959016 11.3736 0.799805 11.6999 0.799805H24.2999C24.6262 0.799805 24.932 0.959016 25.1191 1.22634L31.4191 10.2263C31.5368 10.3944 31.5999 10.5946 31.5999 10.7998V34.1998C31.5999 34.7521 31.1522 35.1998 30.5999 35.1998H5.3999C4.84762 35.1998 4.3999 34.7521 4.3999 34.1998V10.7998C4.3999 10.5946 4.46301 10.3944 4.58067 10.2263L10.8807 1.22634ZM12.2206 2.7998L6.3999 11.115V33.1998H29.5999V11.115L23.7792 2.7998H12.2206Z" fill="#C3CBD4"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.9999 10C16.564 10 15.3999 11.1641 15.3999 12.6C15.3999 14.0359 16.564 15.2 17.9999 15.2C19.4358 15.2 20.5999 14.0359 20.5999 12.6C20.5999 11.1641 19.4358 10 17.9999 10ZM13.3999 12.6C13.3999 10.0595 15.4594 8 17.9999 8C20.5404 8 22.5999 10.0595 22.5999 12.6C22.5999 15.1405 20.5404 17.2 17.9999 17.2C15.4594 17.2 13.3999 15.1405 13.3999 12.6Z" fill="#C3CBD4"/>
    </svg>
</template>

<script>
export default {
    name: 'IconBookingEmpty',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
